// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invProductId } from './InvProduct';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const invProductDocumentId = (z.string());
export const invProductDocument = z.object({
    id: invProductDocumentId,
    product_id: invProductId,
    file_storage_id: fileStorageId,
    display_order: z.number(),
    created_at: z.date(),
});
export const invProductDocumentInitializer = z.object({
    id: invProductDocumentId.optional(),
    product_id: invProductId,
    file_storage_id: fileStorageId,
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
export const invProductDocumentMutator = z.object({
    id: invProductDocumentId.optional(),
    product_id: invProductId.optional(),
    file_storage_id: fileStorageId.optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=InvProductDocument.js.map